/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { DeleteUsersIdMutationResponse, DeleteUsersIdPathParams, DeleteUsersId400, DeleteUsersId403 } from '../entities/DeleteUsersId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getDeleteUsersIdUrl(id: DeleteUsersIdPathParams['id']) {
  return `/users/${id}` as const
}

/**
 * @description Удаление пользователя админом компании
 * @summary Удаление пользователя
 * {@link /users/:id}
 */
export async function deleteUsersId(id: DeleteUsersIdPathParams['id'], config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<DeleteUsersIdMutationResponse, ResponseErrorConfig<DeleteUsersId400 | DeleteUsersId403>, unknown>({
    method: 'DELETE',
    url: getDeleteUsersIdUrl(id).toString(),
    ...requestConfig,
  })
  return res.data
}